/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @providesModule site-constants
 * @flow
 */

// NOTE: We can't just use `location.toString()` because when we are rendering
// the SSR part in node.js we won't have a proper location.
import SiteConfig from "./site.json";
const urlRoot = SiteConfig.url;
const version = '17.0.1';
const babelURL = 'https://unpkg.com/babel-standalone@6.26.0/babel.min.js';

export { babelURL, urlRoot, version };